import { createSelector } from 'reselect'

const getStudentViewData = state => state.student
const getSlideId = (_, slide_uid) => slide_uid

const studentLeadSubmitSelector = createSelector(
	[ getStudentViewData, getSlideId ],
	(student, slideId) => {
		const slide_data = student.slides[slideId]
		let name = ''
		let optionalName = ''
		let isValid = true

		if (slide_data) {
			name = slide_data.name
			optionalName = slide_data.optionalName
			isValid = slide_data.isValid
		}

		return {
			name,
			optionalName,
			isValid,
		}
	}
)

export default studentLeadSubmitSelector
